import { useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import AdminRoute from './helpers/AdminRoute'
import UserRoute from './helpers/UserRoute'
import { NavContext } from './helpers/NavContext'
import Navbar from './components/NavBar/Navbar'
import News from './components/Information/News'
import UsersList from './Pages/Admin/UsersList/UsersList'
import CreateCardInfo from './Pages/Admin/createCardInfo/CreateCardInfo'
import Profile from './Pages/Profile/Profile'
import UpdateCardInfo from './Pages/Admin/UpdateCardInfo/UpdateCardInfo'
import Footer from './components/Footer/Footer'
import IndexList from './Pages/Admin/IndexList/IndexList'
import Register from './Pages/RegistrationPage/Register'
import Login from './Pages/LoginPage/Login'
import HomePage from './Pages/Homepage/HomePage'
import AboutUs from './Pages/About/AboutUs'
import AdminPanel from './Pages/Admin/AdminPanel'
import Submitions from './Pages/Admin/Submitions/Submition'
import Guide from './Pages/Guide/Guide'
import Indexing from './Pages/Indexing/Indexing'
import Contact from './Pages/Contact/Contact'
import Submition from './Pages/Submitions/Submitions'
import Archive from './Pages/Archive/Archive'
import AdminArchive from './Pages/Admin/AdminArchive/AdminArchive'
import UserSubmition from './Pages/UserSubmition/UserSubmition'
import ResetPassword from './Pages/ResetPassword/ResetPassword'
import EnterEmail from './components/EnterEmail/EnterEmail'
import { useDispatch } from 'react-redux'
import { getUser } from './entity/user/model/slice/userSlice'
import Volumes from './Pages/Volumes/Volumes'
import Article from './Pages/Volumes/Article/Article'

function App() {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (localStorage.getItem('accessToken')) {
      dispatch(getUser(localStorage.getItem('accessToken')))
    }
  }, [dispatch])

  return (
    <Router>
      <div className='App'>
        <div className='app-children'>
          <NavContext.Provider value={{ open, setOpen }}>
            <Navbar />
          </NavContext.Provider>
          <Switch>
            <Route exact path='/' component={HomePage} />
            <Route exact path='/submit' component={Submition} />
            <Route exact path='/guide' component={Guide} />
            <Route exact path='/archive' component={Archive} />
            <Route exact path='/volumes' component={Volumes} />
            <Route exact path='/volumes/:volumeId/issue/:issueId' component={Volumes} />
            <Route
              exact
              path='/volumes/:volumeId/issue/:issueId/article/:articleId'
              component={Article}
            />
            <Route exact path='/about' component={AboutUs} />
            <Route exact path='/contact' component={Contact} />
            <Route exact path='/index' component={Indexing} />
            <Route exact path='/news/:id' component={News} />
            <Route exact path='/resetpassword' component={ResetPassword} />
            <Route exact path='/reset' component={EnterEmail} />
            <Route exact path='/login' component={Login} />
            <Route exact path='/register' component={Register} />
            <UserRoute exact path='/user/myprofile' component={Profile} />
            <UserRoute exact path='/user/submitions' component={UserSubmition} />
            <AdminRoute exact path='/admin/dashboard' component={AdminPanel} />
            <AdminRoute exact path='/admin/myprofile' component={Profile} />
            <AdminRoute exact path='/admin/posts' component={CreateCardInfo} />
            <AdminRoute exact path='/admin/index' component={IndexList} />
            <AdminRoute exact path='/admin/updatecardinfo/:id' component={UpdateCardInfo} />
            <AdminRoute exact path='/admin/submitions' component={Submitions} />
            <AdminRoute exact path='/admin/users' component={UsersList} />
            <AdminRoute exact path='/admin/archive' component={AdminArchive} />
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  )
}

export default App
